<template>
  <div class="content">
     账户
    <span class="text-danger">{{ studentNo }}</span>
    为确认是你本人操作，请完成以下验证
    <div class="line margin-top-10 margin-bottom-30"></div>
    <div class="margin-top-20 margin-bottom-20">
      <div class="row">
        <div class="col-md-2">请输入您的绑定邮箱</div>
        <div class="col-md-4">
          <input
            type="text"
            class="form-control"
            v-model="inputEmail"
            style="width: 300px"
          />
          <div class="tips margin-top-10" v-if="emailError">
            {{ emailError }}
          </div>
        </div>
        <div class="col-md-3">
          <button
            class="verification"
            :disabled="sendEmailDisabled"
            @click="verificationImage()"
          >
            {{ smsMessage }}
          </button>
        </div>
      </div>
      <!-- <div class="row">
          <div class="col-md-2"> 请输入验证码</div>
          <div class="col-md-9"><input type="text" class="form-control" style="width:300px;"><div class="tips margin-top-10">(验证码错误！)</div></div>
        </div>
        <div class="  row">
          <div class="col-md-2"> </div>
          <div class="col-md-9"><button class="btn btn-confirm">确定</button></div>
        </div> -->
    </div>
    <div class="explain">
      <span
        >收到验证邮件后，点击邮件中的链接绑定该邮箱，如未收到，请点击重新发送或查看垃圾箱</span
      >
    </div>
    <a-modal
      :title="`图形验证码`"
      :visible="showFlag"
      @cancel="handleCancel"
      :footer="null"
      :width="300"
    >
      <div class="image-random">
        <input
          type="text"
          placeholder="请输入图形验证码"
          class="form-control"
          style="width: 150px"
          v-model="captcha"
        />
        <img v-if="imageCode" @click="getRandomImage" :src="imageCode" />
      </div>
      <div class="image-btn">
        <a-button type="primary" style="width: 100%" @click="sendSms"
          >确定</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "SecuritySettingtab1",
  props: {
    studentNo: {
      type: String,
    },
  },
  data: function () {
    return {
      sendEmailDisabled: false,
      smsMessage: `发送验证邮件`,
      inputEmail: ``,
      emailError: ``,
      randomCode: null,
      showFlag: false,
      smsDisabled: false,
      captcha: ``,
      imageCode: `/static/images/checkcode.png`,
      timer: null,
    };
  },
  created() {
    // this.getApplyData();
  },
  methods: {
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    verificationImage() {
      var myreg = /^([a-zA-Z]|[0-9])(\w|\-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!myreg.test(this.inputEmail)) {
        this.emailError = "邮箱格式不正确！";
        console.log("err");
        return;
      } else {
        this.emailError = ``;
        const number = parseInt(Math.random(1) * Math.pow(10, 10));
        this.randomCode = number;
        this.getRandomImage();
        this.showFlag = true;
      }
    },
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result;
      });
    },
    handleCancel() {
      this.showFlag = false;
      this.captcha = ``;
    },
    sendSms() {
      // this.countdown(120);
      this.axios
        .get(`/biz/user/email/verify/code`, {
          params: {
            captcha: this.captcha,
            checkKey: this.randomCode,
            email: this.inputEmail,
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("发送成功");
            this.showFlag = false;
            this.countdown(120);
          }
        });
    },
    countdown(index) {
      console.log("执行了", index);
      let countdownData = index;
      this.sendEmailDisabled = true;
      console.log(this.timer);

      if (this.timer) {
        console.log(this.timer);
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          console.log("执行了", countdownData);
          this.smsMessage = `${countdownData}秒后重试`;
          countdownData--;
        } else {
          this.smsMessage = `发送验证码`;
          this.sendEmailDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
      console.log(this.timer);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.content {
  background: #fff;
  margin-top: 30px;
  padding: 28px;
  color: #6c6c6c;

  .line {
    border-top: 1px solid #efefef;
  }

  .row {
    margin-bottom: 20px;

    .col-md-2 {
      margin-top: 11px;
      padding-right: 0;
    }
  }

  .explain {
    background-color: #fffbed;
    border: 1px solid #f9efd3;
    padding: 30px 30px 15px;
    line-height: 24px;
  }

  .btn-confirm {
    width: 108px;
    height: 34px;
    background: $bgColor;
    color: #fff;
  }

  .verification {
    background: #FFF1E8;
    border: 1px solid #FF751A;
    white-space: nowrap;
    padding: 6px 20px;
    min-width: 248px;
    color: #FF6A00;
    border-radius: 3px;
  }

  .tips {
    font-size: 13px;
    color: #f00;
  }
}

.image-random {
  display: flex;
}

.image-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/SecuritySettingtab1.vue